import { SelectBox } from "devextreme-react";
import { locale } from "devextreme/localization";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

export default function LocaleSelectBox() {
  const { i18n } = useTranslation();

  const [code, setCode] = useState(i18n.language);

  const handleLocaleChange = useCallback(
    (localeCode: string) => {
      setCode(localeCode);
      i18n.changeLanguage(localeCode);
      locale(localeCode);
      localStorage.setItem("locale", localeCode);
    },
    [i18n]
  );

  return (
    <SelectBox
      dataSource={[
        { code: "pl", name: "Polski" },
        { code: "en", name: "English" },
      ]}
      valueExpr="code"
      displayExpr="name"
      value={code}
      onValueChange={handleLocaleChange}
    />
  );
}
